/**
 * @file src/pages/product-management/logic/stats.js
 * @description Pure math for Product Management page summary stats.
 *
 * No React, no state, no side effects. Easy to unit test.
 */

/**
 * Average unit selling price across the product list.
 * Returns 0 for an empty list (avoids divide-by-zero).
 *
 * @param {Array<{ unitSellingPrice?: number | string }>} products
 * @returns {number}
 */
export const avgUnitSellingPrice = (products) => {
  if (products.length === 0) return 0;
  const total = products.reduce(
    (sum, p) => sum + (parseFloat(p.unitSellingPrice) || 0),
    0,
  );
  return total / products.length;
};

/**
 * Count how many products have a non-zero tax rate.
 *
 * @param {Array<{ taxRate?: number | string }>} products
 * @returns {number}
 */
export const countTaxable = (products) =>
  products.filter((p) => parseFloat(p.taxRate) > 0).length;
